__turbopack_context__.v({
  "blurredNotificationImg": "Steps-module__V5FaXa__blurredNotificationImg",
  "buttonLink": "Steps-module__V5FaXa__buttonLink",
  "buttons": "Steps-module__V5FaXa__buttons",
  "container": "Steps-module__V5FaXa__container",
  "content": "Steps-module__V5FaXa__content",
  "img": "Steps-module__V5FaXa__img",
  "linkWithArrow": "Steps-module__V5FaXa__linkWithArrow",
  "subContainer": "Steps-module__V5FaXa__subContainer",
  "title": "Steps-module__V5FaXa__title",
});
